export default __webpack_public_path__ + "4ea497c612b3c9849b4dab70d45cf32b.png";